module.exports = __webpack_public_path__ + "img/Syg_icon_tuis.7dc81f12.png";